import { useDispatch, useSelector } from 'react-redux';
import FrameChatPanel from 'components/Panel/Chat/ChatPanel/FrameChatPanel';
import { setInspectorLeftPanelWidth } from 'redux/mode/actions';
import { RootReducer } from 'redux/reducers';
import ResizablePanel from '../ResizablePanel';
import * as S from './styles';

interface InspectorLeftPanelProps {
	frameId: string;
	overlay?: boolean;
	visible?: boolean;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
}

const InspectorLeftPanel = ({
	frameId,
	overlay,
	visible = true,
	onMouseEnter,
	onMouseLeave,
}: InspectorLeftPanelProps) => {
	const dispatch = useDispatch();
	const inspectorLeftPanelWidth = useSelector(
		(r: RootReducer) => r.mode.inspectorLeftPanelWidth
	);

	return (
		<S.PanelWrapper
			$overlay={overlay}
			$visible={visible}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			data-panel
		>
			<ResizablePanel
				resizeOnSide="right"
				size={inspectorLeftPanelWidth}
				onResize={(w) => dispatch(setInspectorLeftPanelWidth(w))}
			>
				<FrameChatPanel frameId={frameId} />
			</ResizablePanel>
		</S.PanelWrapper>
	);
};

export default InspectorLeftPanel;
